/**
 * OnboardingPage
 * Full-page wrapper for the onboarding wizard
 */

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useOnboarding } from '@/contexts/OnboardingContext.context'
import { OnboardingWizard } from '@/components/onboarding'

export default function OnboardingPage() {
  const { isOnboardingComplete } = useOnboarding()
  const navigate = useNavigate()

  // Redirect to home if onboarding is already complete
  useEffect(() => {
    if (isOnboardingComplete) {
      navigate('/', { replace: true })
    }
  }, [isOnboardingComplete, navigate])

  return <OnboardingWizard />
}
